import { render, staticRenderFns } from "./Halfpage.vue?vue&type=template&id=94e48f42&scoped=true&"
import script from "./Halfpage.vue?vue&type=script&lang=js&"
export * from "./Halfpage.vue?vue&type=script&lang=js&"
import style0 from "./Halfpage.vue?vue&type=style&index=0&id=94e48f42&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94e48f42",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
